// Store-owner details used by every price display and purchase button.
export const offer: {
  price: number | null;
  currency: string | null;
  checkoutUrl: string | null;
  guaranteeDays: number | null;
} = {
  price: 19,
  currency: 'USD',
  checkoutUrl: 'https://hyrox-mega-pack.impultienda.ar/checkout',
  guaranteeDays: 10,
};

export const OFFER_ANCHOR = '#offer-details';

export const heroMockupUrl =
  'https://cdn.magicpatterns.com/uploads/2vgU6kVa9o6aJepXDzUSK5/Mega_pack_HYROX_en_seis_pantallas.png';

export const included = [
  '1 complete 26-week training plan',
  '5 strategic bonuses',
  '78 fully written workouts',
  '6 organized training blocks',
  '3 scheduled sessions per week',
  'Foundation & Standard options',
  'Exercises, sets, reps & recovery',
  'Downloadable, printable PDF',
];
